export default () => import(/* webpackChunkName: "navigation" */ '../components/navigation')
  .then(({ default: Navigation }) => new Navigation())
  .catch((error) => `Navigation ${error}`);
